import React from 'react';
import './ConditionsPage.scss';
import spineNerveImage from '../assets/conditions/spine-nerve.jpg';
import softTissueImage from '../assets/conditions/soft-tissue-joint-issues.jpg';
import headPosturalImage from '../assets/conditions/head-postural-conditions.jpg';
import injuryRecoveryImage from '../assets/conditions/injury-recovery.jpg';

const ConditionsPage = () => {
    const conditions = [
        {
            category: 'Spine / Nerve Conditions',
            image: spineNerveImage,
            conditions: [
                { name: 'Neck Pain' },
                { name: 'Mid Back Pain' },
                { name: 'Low Back Pain' },
                { name: 'Sciatica' },
                { name: 'Disc Herniation' },
                { name: 'Spinal Restrictions' }
            ]
        },
        {
            category: 'Soft Tissue / Joint Issues',
            image: softTissueImage,
            conditions: [
                { name: 'Muscle Tightness & Spasms' },
                { name: 'Shoulder, Hip, and Knee pain' },
                { name: 'Sprains and Strains' },
                { name: 'Tendonitis' },
                { name: 'Joint Inflammation' },
                { name: 'Arthritis-Related Pain' }
            ]
        },
        {
            category: 'Head / Postural Conditions',
            image: headPosturalImage,
            conditions: [
                { name: 'Headaches' },
                { name: 'Migraines' },
                { name: 'Tension-Type Headaches' },
                { name: 'Posture Imbalances' },
                { name: 'Tech Neck' },
                { name: 'Jaw Tension (TMJ Related)' }
            ]
        },
        {
            category: 'Injury Recovery',
            image: injuryRecoveryImage,
            conditions: [
                { name: 'Sports Injuries' },
                { name: 'Workplace Injuries (Workers Compensation)' },
                { name: 'Auto Accident Injuries' },
                { name: 'Repetitive Strain Injuries' }
            ]
        }
    ];

    return (
        <div className="conditions-page">
            <div className="conditions-hero">
                <h1>Conditions We Treat</h1>
                <p>Comprehensive chiropractic care for a wide range of conditions</p>
            </div>

            <div className="conditions-container">
                {conditions.map((category, index) => (
                    <div key={index} className="condition-detailed-card">
                        <div className="condition-content">
                            <h2 className="category-title">
                                {category.category}
                            </h2>
                            <div className="conditions-list">
                                <ul>
                                    {category.conditions.map((condition, idx) => (
                                        <li key={idx}>
                                            <h3>{condition.name}</h3>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="condition-image">
                            <img src={category.image} alt={category.category} />
                        </div>
                    </div>
                ))}
            </div>

            <div className="treatment-approach">
                <h2>Our Treatment Approach</h2>
                <div className="approach-grid">
                    <div className="approach-item">
                        <div className="approach-icon">🔍</div>
                        <h3>Comprehensive Assessment</h3>
                        <p>Thorough evaluation to understand your condition and needs</p>
                    </div>
                    <div className="approach-item">
                        <div className="approach-icon">💡</div>
                        <h3>Customized Treatment</h3>
                        <p>Personalized care plan designed for your specific condition</p>
                    </div>
                    <div className="approach-item">
                        <div className="approach-icon">📈</div>
                        <h3>Progress Tracking</h3>
                        <p>Monitor your improvement and adjust treatment as needed</p>
                    </div>
                    <div className="approach-item">
                        <div className="approach-icon">🌟</div>
                        <h3>Long-term Wellness</h3>
                        <p>Empower you with tools for ongoing health and prevention</p>
                    </div>
                </div>
            </div>

            <div className="cta-banner">
                <h2>Not Sure If We Can Help?</h2>
                <p>Schedule a consultation to discuss your specific condition and treatment options</p>
                <a href="tel:9493719377" className="btn-primary-large">Call (949) 371-9377</a>
            </div>
        </div>
    );
};

export default ConditionsPage;

